export default class StatusRegistroMatricula {
  constructor(obj) {
    this.codigo = obj != null ? obj.codigo : '';
    this.descricao = obj != null ? obj.descricao : '';    
  }  
}


